import { useState, useRef, useEffect } from "react";
import "./TagInput.css"
import { CgClose } from "react-icons/cg";

const TagInput = ({tags =['ff'], setTags}) => {
  const maxTags = 10;
//   const [tags, setTags] = useState(["coding", "nepal"]);
  const inputRef = useRef(null);

//   useEffect(() => {
//     inputRef.current.focus();
//   }, []);

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       let newTag = e.target.value.trim();
//       if (newTag && !tags.includes(newTag) && tags.length < maxTags) {
//         setTags([...tags, newTag]);
//       }
//       e.target.value = "";
//     }
//   };

//   const removeTag = (tagToRemove) => {
//     setTags(tags.filter((tag) => tag !== tagToRemove));
//   };

const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      let newTag = e.target.value.trim();
      if (newTag && !tags?.includes(newTag) && tags?.length < maxTags) {
        const updatedTags = [...tags, newTag];
        setTags(updatedTags); // Mettre à jour l'état dans AddService
      }
      e.target.value = "";
    }
  };

  const removeTag = (tagToRemove) => {
    const updatedTags = tags?.filter((tag) => tag !== tagToRemove);
    setTags(updatedTags);
  };

  const removeAllTags = () => {
    setTags([]);
  };

  return (
    <div className="wrapper_1 ">
        <label htmlFor="tags" className="block text-sm font-medium text-gray-700 mb-1 text-start">Mot clé</label>
      <div className="content_1">
        <ul className="flex flex-wrap gap-2">
          {tags?.map((tag, index) => (
            <li
              key={index}
              className="bg-gray-50 border text-gray-600 px-3 py-1 rounded flex items-center"
            >
              {tag}
              <button
                onClick={() => removeTag(tag)}
                className="ml-2 size-5 text-[14px] flex items-center justify-center text-white hover:bg-gray-200 bg-gray-300 rounded-full p-1"
              >
                <CgClose />
              </button>
            </li>
          ))}
          <input
            type="text"
            ref={inputRef}
            spellCheck="false"
            onKeyDown={handleKeyDown}
            className="outline-none text-sm px-2 py-1 flex-grow"
            placeholder="Ajouter un mot clé..."
          />
        </ul>
      </div>
      <div className="details flex justify-between items-center mt-3 text-sm">
        <p>
          <span className="font-bold">{maxTags - tags?.length}</span> mots clés restantes
        </p>
        <button
          onClick={removeAllTags}
          className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
        >
          Tout Supprimer
        </button>
        {/* <button className="bg-red-500 p-2"></button> */}
      </div>
    </div>
  );
};

export default TagInput;
